// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__1bfzo","location":"Details_location__pGUHV","col":"Details_col__3Rrjh","price":"Details_price__3BAHB"};